export type CategoryId = 'recyclage' | 'dechets' | 'organiques' | 'jardin' | 'lourds' | 'speciales'

export interface Category {
  id: CategoryId
  label: string
  dot: string
  chip: string
  time: string
}

export const categories: Record<CategoryId, Category> = {
  recyclage: {
    id: 'recyclage',
    label: 'Recyclage — boîte bleue',
    dot: 'bg-[#4f46e5]',
    chip: 'bg-[#eef2ff] text-[#4338ca]',
    time: '7 h',
  },
  dechets: {
    id: 'dechets',
    label: 'Déchets',
    dot: 'bg-[#475569]',
    chip: 'bg-slate-100 text-slate-700',
    time: '7 h',
  },
  organiques: {
    id: 'organiques',
    label: 'Matières organiques',
    dot: 'bg-[#a16207]',
    chip: 'bg-amber-50 text-amber-800',
    time: '7 h',
  },
  jardin: {
    id: 'jardin',
    label: 'Déchets de jardin',
    dot: 'bg-[#0f766e]',
    chip: 'bg-teal-50 text-teal-800',
    time: '7 h',
  },
  lourds: {
    id: 'lourds',
    label: 'Objets lourds',
    dot: 'bg-[#7c3aed]',
    chip: 'bg-violet-50 text-violet-800',
    time: '7 h',
  },
  speciales: {
    id: 'speciales',
    label: 'Collectes spéciales',
    dot: 'bg-[#db2777]',
    chip: 'bg-pink-50 text-pink-800',
    time: '7 h',
  },
}

/** Collections by ISO date (YYYY-MM-DD) for the citizen's address. */
export const collectionsByDate: Record<string, CategoryId[]> = {
  '2026-08-06': ['recyclage', 'dechets'],
  '2026-08-13': ['recyclage', 'dechets', 'organiques', 'lourds'],
  '2026-08-20': ['dechets', 'organiques', 'jardin'],
  '2026-08-27': ['recyclage', 'dechets', 'jardin'],
  '2026-09-03': ['recyclage', 'dechets', 'organiques', 'jardin'],
  '2026-09-11': ['recyclage', 'dechets', 'jardin'],
  '2026-09-17': ['dechets', 'organiques'],
  '2026-09-24': ['recyclage', 'dechets', 'speciales'],
  '2026-07-23': ['recyclage', 'dechets'],
  '2026-07-30': ['dechets', 'organiques'],
}

export const monthNames = [
  'JANVIER',
  'FÉVRIER',
  'MARS',
  'AVRIL',
  'MAI',
  'JUIN',
  'JUILLET',
  'AOÛT',
  'SEPTEMBRE',
  'OCTOBRE',
  'NOVEMBRE',
  'DÉCEMBRE',
]

export const weekdayNames = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim']

export const longWeekdayNames = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi']

export const longMonthNames = [
  'janvier',
  'février',
  'mars',
  'avril',
  'mai',
  'juin',
  'juillet',
  'août',
  'septembre',
  'octobre',
  'novembre',
  'décembre',
]

export function toKey(date: Date): string {
  const month = `${date.getMonth() + 1}`.padStart(2, '0')
  const day = `${date.getDate()}`.padStart(2, '0')
  return `${date.getFullYear()}-${month}-${day}`
}

export function formatLongDate(date: Date): string {
  const weekday = longWeekdayNames[date.getDay()]
  return `${weekday.charAt(0).toUpperCase()}${weekday.slice(1)} ${date.getDate()} ${longMonthNames[date.getMonth()]}`
}
